import { render, staticRenderFns } from "./VueCard.vue?vue&type=template&id=20ebf3ec&scoped=true&"
import script from "./VueCard.vue?vue&type=script&lang=js&"
export * from "./VueCard.vue?vue&type=script&lang=js&"
import style0 from "./VueCard.vue?vue&type=style&index=0&id=20ebf3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebf3ec",
  null
  
)

component.options.__file = "VueCard.vue"
export default component.exports